import { CHART_COLORS } from "utils/designTokens";

export const getStackedBarChartOptions = (categories = [], yAxisTitle = 'Percentage (%)') => {

  const fullCategoryNames = [...categories];

  return {
    chart: {
      stacked: true,
      foreColor: "#fff",
      background: "transparent",
      toolbar: {
        show: false, // Hide download chart as (svg, csv, pr png ..)
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 500,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      }
    },
    tooltip: {
      style: {
        fontSize: "10px",
        fontFamily: "Sora",
      },
      onDatasetHover: {
        style: {
          fontSize: "10px",
          fontFamily: "Sora",
        },
      },
      theme: "dark",
      x: {
        show: false
      },
      custom: function({ series, seriesIndex, dataPointIndex, w }) {
        const fullCategoryName = fullCategoryNames[dataPointIndex];
        const seriesName = w.globals.seriesNames[seriesIndex];
        const value = series[seriesIndex][dataPointIndex];
        const color = w.globals.colors[seriesIndex];

          let tooltipContent = `
            <div  style="padding: 6px 10px; font-weight: 500; font-size: 13px; color: white; background: #000; 
                  border-bottom: 1px solid rgba(255, 255, 255, 0.1);">
              ${fullCategoryName}
            </div>
            <div style="padding: 6px 10px;">
          `;

          tooltipContent += `
            <div style="display: flex; align-items: center; margin: 4px 0;">
              <div>
                <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background-color: ${color}; margin-right: 6px;"></span>
                <span style="font-size: 12px; color: #fff;">${seriesName}:&nbsp;</span>
              </div>
              <div style="font-weight: 700; font-size: 14px; color: rgba(255, 255, 255, 0.85);">${value}%</div>
            </div>
          `;

        tooltipContent += `</div>`;

        return tooltipContent;
      }
    },
    xaxis: {
      categories: categories.map(c => c.split(' ')[0]),
      show: true,
      labels: {
        show: true,
        style: {
          colors: "#A0AEC0",
          fontSize: "10px",
        },
        trim: true,
        maxHeight: 90,
        rotate: -45
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      show: true,
      color: "#A0AEC0",
      labels: {
        show: true,
        style: {
          colors: "#A0AEC0",
          fontSize: "10px",
        },
      },
      title: {
        text: yAxisTitle,
        rotate: -90,
        offsetX: 5,
        style: {
          color: '#A0AEC0',
          fontSize: '10px',
          fontFamily: 'Sora',
          fontWeight: 'normal'
        }
      }
    },
    grid: {
      borderColor: "#56577A",
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 10
      }
    },
    fill: {
      type: "solid",
      opacity: 1,
    },
    colors: CHART_COLORS,
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "28px",
        distributed: false,
        endingShape: 'rounded',
      },
    },
    legend: {
      show: true,
      fontSize: "12px",
      position: "bottom",
      horizontalAlign: "center",
      offsetY: 10,
      markers: {
        shape: "circle",
        width: 8,
        height: 8,
        strokeWidth: 0,
        radius: 12,
        fillColors: CHART_COLORS,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5
      },
      labels: {
        colors: "#fff",
      },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              borderRadius: 0,
              columnWidth: "40%",
            },
          },
          legend: {
            position: "bottom",
            offsetY: 0,
            itemMargin: {
              horizontal: 5,
              vertical: 5
            },
          },
          xaxis: {
            labels: {
              rotate: -90,
              trim: true,
              hideOverlappingLabels: true,
            }
          }
        },
      },
    ],
  };
};